module.exports = __webpack_public_path__ + "static/media/page_16.f8f93bf0.jpg";